"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuccessfulStatusCode = exports.isServerErrorStatusCode = exports.isClientErrorStatusCode = void 0;
exports.isQueryNotFoundError = isQueryNotFoundError;
exports.isHttpStatusError = isHttpStatusError;
exports.isNetworkError = isNetworkError;
exports.isRetriableClientError = isRetriableClientError;
function isQueryNotFoundError(error) {
    return (typeof error === "object" &&
        error !== null &&
        "code" in error &&
        error.code === "QUERY_NOT_FOUND");
}
function isHttpStatusError(error) {
    return (typeof error === "object" &&
        error !== null &&
        "status" in error &&
        typeof error.status === "number");
}
function isNetworkError(error) {
    return (typeof error === "object" && error !== null && "code" in error && typeof error.code === "string");
}
function isRetriableClientError(response) {
    if (typeof response === "object" && response !== null) {
        // Check error field first
        if ("error" in response && isQueryNotFoundError(response.error)) {
            return false;
        }
        // Check rspBody if no error
        if ("rspBody" in response && isQueryNotFoundError(response.rspBody)) {
            return false;
        }
    }
    return true;
}
const isClientErrorStatusCode = (status) => {
    return status >= 400 && status < 500;
};
exports.isClientErrorStatusCode = isClientErrorStatusCode;
const isServerErrorStatusCode = (status) => {
    return status >= 500 && status < 600;
};
exports.isServerErrorStatusCode = isServerErrorStatusCode;
const isSuccessfulStatusCode = (statusCode) => statusCode >= 200 && statusCode < 300;
exports.isSuccessfulStatusCode = isSuccessfulStatusCode;
//# sourceMappingURL=http-utils.js.map